import { StringParam, NumberParam, useQueryParams, withDefault } from 'use-query-params';
import { USER_SOURCE } from '@mp';

type QueryParams = {
  os: string;
  SourceTrackedEventID?: number | null;
  position?: number | null;
  list_view_id?: number | null;
};

export const useTrackingQueryParams = (): {
  queryParams: QueryParams;
  setListViewId: ({ data: { id } }: { data: { id: number } }) => void;
  clearListViewId: () => void;
} => {
  const [{ os, SourceTrackedEventID, position, list_view_id }, setQuery] = useQueryParams({
    os: withDefault(StringParam, USER_SOURCE.other),
    SourceTrackedEventID: NumberParam,
    // position should not be tracked on every instance of assignment view events,
    // for that reason, no default params are used here,
    // instead, it's set at AssignmentsList/JobsList
    position: NumberParam,
    list_view_id: NumberParam,
  });

  const setListViewId = ({ data: { id: list_view_id } }: { data: { id: number } }) =>
    setQuery({ list_view_id }, 'replaceIn');
  // Clears ID until new list view POST completes on page change
  const clearListViewId = () => setQuery({ list_view_id: undefined }, 'replaceIn');

  // Filter out null/undefined values to avoid including empty keys in request payloads.
  // This is necessary because use-query-params v2 returns `null` for missing params,
  // and JSON.stringify preserves null values (unlike undefined which gets stripped).
  const queryParams: QueryParams = { os };
  if (SourceTrackedEventID !== null && SourceTrackedEventID !== undefined) {
    queryParams.SourceTrackedEventID = SourceTrackedEventID;
  }
  if (position !== null && position !== undefined) {
    queryParams.position = position;
  }
  if (list_view_id !== null && list_view_id !== undefined) {
    queryParams.list_view_id = list_view_id;
  }

  return {
    queryParams,
    setListViewId,
    clearListViewId,
  };
};
